import { render, staticRenderFns } from "./PositionsMarkers.vue?vue&type=template&id=32ab8a93&"
import script from "./PositionsMarkers.vue?vue&type=script&lang=ts&"
export * from "./PositionsMarkers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports